import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";
import { getFVOfActivity } from "./fanvoice";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  fanChoices: [],
  fetchLoading: false,
  singleFanChoice: null,
};

const slice = createSlice({
  name: "fanchoice",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    stopLoading(state) {
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateFanChoiceSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.fanChoices = state.fanChoices.map((fanChoice) => {
        if (fanChoice.id === action.payload.id) {
          return action.payload;
        }
        return fanChoice;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getFanChoiceSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.fanChoices = action.payload;
    },

    // GET SINGLE SUCCESS
    getSingleFVSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleFanChoice = action.payload;
    },

    // GET PRODUCTS
    createFVSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.fanChoices = [...state.fanChoices, action.payload];
    },

    // DELETE EVENT
    deleteFVSuccess(state, action) {
      const fvId = action.payload;
      state.fanChoices = state.fanChoices.filter((game) => game.id !== fvId);
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function getFanChoices({ season_id, game_id, yesno }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("fan-activities", {
        params: {
          season_id,
          game_id,
          yesno,
        },
      });
      dispatch(slice.actions.getFanChoiceSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSingleFanChoice({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`fan-activities/${id}`);
      dispatch(getFVOfActivity({ id: response.data.data.id }));
      dispatch(slice.actions.getSingleFVSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createFanChoices({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("fan-activities", data);
      dispatch(slice.actions.createFVSuccess(response.data.data));
      enqueueSnackbar("Fan Choice is added successfully");
      navigate(PATH_DASHBOARD.fanChoice.list);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function udpateFanChoice({ id, data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`fan-activities/${id}`, data);
      dispatch(slice.actions.updateFanChoiceSuccess(response.data.data));
      enqueueSnackbar("Fan Choice is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteFanChoice({ id, enqueueSnackbar, setOpenConfirm }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`fan-activities/${id}`);
      dispatch(slice.actions.deleteFVSuccess(id));
      enqueueSnackbar("Fan Choice is deleted successfully");
      setOpenConfirm(false);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}
